import playStore from "../../assets/PaymentIcons/google-play.svg";
import apple from "../../assets/PaymentIcons/apple.svg";
import mastercard from "../../assets/PaymentIcons/mastercard.svg";
import visa from "../../assets/PaymentIcons/visa.svg";
import coin_icon from "../../assets/icons/coin_icon.svg";
import nuevi from "../../assets/icons/nuevi.svg";
import usdt_icon from "../../assets/images/USDT_ICON.png";
import eth_icon from "../../assets/images/ETH_ICON.png";
import usd_icon from "../../assets/images/tron-trx-logo.png";
import usd_coin from "../../assets/images/usd-coin-usdc-logo.png";
import checkoutCom from "../../assets/icons/checkoutCom.svg";
import googlepay from "../../assets/PaymentIcons/Google_Pay_Logo.svg";
import radioActiveBtn from "../../assets/icons/UpdatedCheckoutPage/radioActiveBtn.svg";
import radioBtn from "../../assets/icons/UpdatedCheckoutPage/radioBtn.svg";
import InfoIcon from "../../assets/icons/UpdatedCheckoutPage/InfoIcon.svg";
import clearicon from "../../assets/icons/UpdatedCheckoutPage/clearicon.svg";
import greenDot from "../../assets/icons/UpdatedCheckoutPage/greenDot.svg";
import crossIcon from "../../assets/icons/crosIcon.svg";
import ProfileIcon from "../../assets/icons/UpdatedCheckoutPage/ProfileIcon.svg";
import EmailIcon from "../../assets/icons/UpdatedCheckoutPage/EmailIcon.svg";
import ContactNumber from "../../assets/icons/UpdatedCheckoutPage/Contact_number.svg";
import CheckSolidGreenIcon from "../../assets/icons/check-solid-green.svg";
import CountryIcon from "../../assets/icons/CountryIcon.svg";
import CityIcon from "../../assets/icons/country.svg";
import PDFDoc from "../../assets/Docs/Alpha Capital Group - Terms and Conditions.pdf";
import { Modal, Tooltip } from "antd";
import "antd/dist/reset.css"; // Use this if you need to reset antd styles
import CheckCircle from "../../assets/icons/UpdatedCheckoutPage/CheckCircle.svg";
import BlankCircle from "../../assets/icons/UpdatedCheckoutPage/BlankCircle.svg";

import "./UpdatedCheckoutPage.scss";

import Select from "react-select";

import { useEffect, useState } from "react";
import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
} from "@mui/material";
import CustomLoadingButton from "../../reusableComponents/CustomLoadingButton";
import axios from "axios";
import logoutReducer from "../../store/reducers/logout";
import {
  addChallenge,
  savePaymentIntent,
} from "../../store/reducers/paymentReducer";
import { axiosInstance } from "../../Axios";
import { useNavigate } from "react-router";
import toast from "react-hot-toast";
import { country } from "../../utilities/country";
import PDFPreview from "../../reusableComponents/PDFReview/PDFReview";

export const platformList = [
  { name: "MetaTrader 5 ", value: "mt5" },
  { name: "cTrader", value: "ctrader" },
  { name: "DX Trade", value: "dxtrade" },
  { name: "Trade Locker", value: "tradelocker" },
  { name: "Alpha Trader", value: "alphatrader", disabled: true },
];
export const paymentMethods = [
  { name: "Nuvei", value: "nuvei" },
  { name: "Checkout", value: "checkout" },
  { name: "Coin payments", value: "coinspayment" },
];
export const payout_type = [
  {
    name: "Bi-Weekly",
    value: 1,
  },
  {
    name: "On demand",
    value: 2,
  },
];
export const profit_split = [
  {
    name: "80%",
    value: 80,
  },
  {
    name: "90%",
    value: 90,
  },
];
export const paymentMethodDetails = {
  checkout: {
    icon: checkoutCom,
    supported: [mastercard, visa, googlepay],
  },
  nuvei: {
    icon: nuevi,
    supported: [mastercard, visa, apple, playStore],
  },
  coinspayment: {
    icon: coin_icon,
    supported: [],
  },
};
export const CRYPTO_OPTIONS = [
  {
    label: "USDT-TRON",
    value: "USDT.TRC20",
    icon: usd_icon,
    netWorkType: "NETWORK-TRON",
  },
  {
    label: "USDC-TRON",
    value: "USDC.TRC20",
    icon: usd_icon,
    netWorkType: "NETWORK-TRON",
  },
  {
    label: "COIN-ETH",
    value: "ETH",
    icon: eth_icon,
    netWorkType: "NETWORK-ETH",
  },
  {
    label: "COIN-USDT",
    value: "USDT.ERC20",
    icon: usdt_icon,
    netWorkType: "NETWORK-ETH",
  },
  {
    label: "COIN-USDC",
    value: "USDC",
    icon: usd_coin,
    netWorkType: "NETWORK-ETH",
  },
];

export const PayoutTypeSelector = ({
  payout_type,
  selectedPayoutType,
  setSelectedPayoutType,
  showObjectives,
}) => {
  const [showInfo, setShowInfo] = useState(null);

  const handleMouseLeave = () => {
    setShowInfo(null);
  };

  return (
    <div className="payoutType">
      <div className="account_balance_header">
        <h2>Payout Type</h2>
      </div>
      <div className="payoutType_main">
        {payout_type?.map((payoutType, index) => {
          const isActive = payoutType.value === selectedPayoutType;

          return (
            <label
              key={payoutType.value}
              htmlFor={`payout-${payoutType.value}`}
              className={isActive ? "active_payout" : ""}
              onClick={() => setSelectedPayoutType(payoutType.value)}
              onMouseLeave={handleMouseLeave}
            >
              {payoutType.value === 2 && (
                <span className="green_discount_badge">10% Off</span>
              )}
              <img
                src={isActive ? CheckCircle : BlankCircle}
                alt={isActive ? "Selected" : "Not Selected"}
              />
              <p>{payoutType.name}</p>
              <input
                type="radio"
                name="payoutType"
                id={`payout-${payoutType.value}`}
                checked={isActive}
                onChange={() => {}} // To silence React warning
              />
              {showObjectives && (
                <img
                  src={InfoIcon}
                  alt="Info"
                  className="info-icon"
                  onMouseEnter={() => setShowInfo(index)}
                />
              )}

              {showObjectives && showInfo === index && (
                <div
                  className="tooltip-box"
                  style={{ backgroundColor: "#000" }}
                >
                  <p>
                    {payoutType.value === 1
                      ? "Payout option fixed every 14 days cycle"
                      : "Payout requests on demand, anytime, once 2 requirements are met "}
                    {payoutType.value === 2 && (
                      <a
                        href="https://help.alphacapitalgroup.uk/en/articles/10102634-performance-fee-on-demand"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (learn more)
                      </a>
                    )}
                  </p>
                </div>
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
};

export const ProfitSplitSelector = ({
  profit_split,
  selectedProfitSplit,
  setSelectedProfitSplit,
}) => {
  return (
    <div className="payoutType">
      <div className="account_balance_header">
        <h2>Profit Split</h2>
      </div>
      <div className="payoutType_main">
        {profit_split?.map((option) => {
          const isActive = option.value === selectedProfitSplit;

          return (
            <label
              key={option.value}
              htmlFor={`profit-split-${option.value}`}
              className={isActive ? "active_payout" : ""}
              onClick={() => setSelectedProfitSplit(option.value)}
            >
              <img
                src={isActive ? radioActiveBtn : radioBtn}
                alt={isActive ? "Selected" : "Not Selected"}
              />
              <p>{option.name}</p>
              <input
                type="radio"
                name="profitSplit"
                id={`profit-split-${option.value}`}
                checked={isActive}
                onChange={() => {}}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
};

export function addMetaScripts() {
  const meta_noscript = document.createElement("noscript");
  const img = document.createElement("img");
  img.height = "1";
  img.width = "1";
  img.alt = "";
  img.style = "display:none";
  img.src =
    "https://www.facebook.com/tr?id=651339132566810&ev=PageView&noscript=1";
  meta_noscript.appendChild(img);

  document.body.appendChild(meta_noscript);
}

export function addGoogleTagScripts() {
  const script1 = document.createElement("script");
  script1.src =
    "https://www.googletagmanager.com/gtag/js?id=AW-11028943102%22%3E";
  script1.async = true;
  document.body.appendChild(script1);

  const script2 = document.createElement("script");
  script2.textContent = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'AW-11028943102');`;
  document.body.appendChild(script2);
}

export const countries = country.map((country) => ({
  code: country.iso,
  label: country.country,
  phone: country.code?.replace("-", ""),
}));

export const CryptoModal = ({
  setSelectedCrypto,
  openCryptoOptionsBD = false,
  setOpenCryptoOptionsBD,
  selectedCrypto,
  cancelCrypto,
}) => {
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "80%",
          maxHeight: 435,
          background: "#08131F",
          borderRadius: "16px",
          border: "1px solid #808080b5",
        },
      }}
      maxWidth="xs"
      open={openCryptoOptionsBD}
      onClose={() => setOpenCryptoOptionsBD(false)}
    >
      <DialogTitle sx={{ backgroundColor: "#01030c", color: "#fff" }}>
        Select Coin Payment Method
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ backgroundColor: "#01030c", color: "#fff" }}
      >
        <div className="options">
          <div className="options_coins">
            <div className="heading">
              <h1>Select Coin Payment Method</h1>
              <img
                src={crossIcon}
                onClick={() => {
                  selectedCrypto === null && cancelCrypto();
                  setOpenCryptoOptionsBD(false);
                }}
                alt="close modal"
                style={{ cursor: "pointer" }}
              />
            </div>
            <div className="option_wrapper">
              {CRYPTO_OPTIONS.map(({ label, value, icon, netWorkType }) => (
                <label
                  htmlFor={`crypto-${value}`}
                  className={`optionC ${
                    value === selectedCrypto
                      ? "active_label selected_coin_method"
                      : ""
                  }`}
                  key={value}
                  onClick={() => setSelectedCrypto(value)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                    className="coin-payment-methods"
                  >
                    <img
                      src={icon}
                      alt={label}
                      width="10%"
                      className="coin_icon"
                    />
                    <p>{label}</p>
                  </div>
                  <div className="coinMethonEnd">
                    <input
                      type="radio"
                      name="coin"
                      id={`crypto-${value}`}
                      value={value}
                      checked={value === selectedCrypto}
                      onChange={(e) => setSelectedCrypto(e.target.value)}
                    />
                    <p>{netWorkType}</p>
                  </div>
                </label>
              ))}
            </div>
            <button
              className="confirm_btn"
              onClick={() => {
                if (selectedCrypto) {
                  setOpenCryptoOptionsBD(false);
                } else {
                  toast.error("Please select a coin method");
                }
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const PrivacyPolicy = () => {
  return (
    <div className="privacy_policy_box">
      <p>
        Thank you for choosing to be part of our community at Alpha Capital
        Group Limited ("Company," "we," "us," or "our"). We are committed to
        protecting your personal information and your right to privacy. If you
        have any questions or concerns about this privacy notice or our
        practices with regard to your personal information, please contact us at
        accounts@alphacapitalgroup.uk.
      </p>
      <p>
        This privacy notice describes how we might use your information if you:
        <br />
        Visit our website at http://www.alphacapitalgroup.uk
        <br />
        Engage with us in other related ways ― including any sales, marketing,
        or events
      </p>
      <p>
        In this privacy notice, if we refer to:
        <br />
        "Website," we are referring to any website of ours that references or
        links to this policy
      </p>
      <p>
        "Services," we are referring to our Website, and other related services,
        including any sales, marketing, or events
      </p>
      <p>
        The purpose of this privacy notice is to explain to you in the clearest
        way possible what information we collect, how we use it, and what rights
        you have in relation to it. If there are any terms in this privacy
        notice that you do not agree with, please discontinue use of our
        Services immediately.
      </p>
      <p>
        Please read this privacy notice carefully, as it will help you
        understand what we do with the information that we collect.
      </p>

      <h3>WHAT INFORMATION DO WE COLLECT?</h3>
      <p>Personal information you disclose to us</p>
      <p>In Short: We collect personal information that you provide to us.</p>
      <p>
        We collect personal information that you voluntarily provide to us when
        you register on the Website, express an interest in obtaining
        information about us or our products and Services, when you participate
        in activities on the Website or otherwise when you contact us.
      </p>
      <p>
        The personal information that we collect depends on the context of your
        interactions with us and the Website, the choices you make and the
        products and features you use. The personal information we collect may
        include the following:
      </p>
      <p>
        Personal Information Provided by You. We collect names; phone numbers;
        email addresses; mailing addresses; contact preferences; and other
        similar information.
      </p>
      <p>
        Payment Data. We may collect data necessary to process your payment if
        you make purchases, such as your payment instrument number (such as a
        credit card number), and the security code associated with your payment
        instrument. All payment data is stored by Stripe . You may find their
        privacy notice link(s) here: https://stripe.com/gb/privacy.
      </p>
      <p>
        All personal information that you provide to us must be true, complete
        and accurate, and you must notify us of any changes to such personal
        information.
      </p>
      <p>Information automatically collected</p>
      <p>
        In Short: Some information — such as your Internet Protocol (IP) address
        and/or browser and device characteristics — is collected automatically
        when you visit our Website.
      </p>
      <p>
        We automatically collect certain information when you visit, use or
        navigate the Website. This information does not reveal your specific
        identity (like your name or contact information) but may include device
        and usage information, such as your IP address, browser and device
        characteristics, operating system, language preferences, referring URLs,
        device name, country, location, information about how and when you use
        our Website and other technical information. This information is
        primarily needed to maintain the security and operation of our Website,
        and for our internal analytics and reporting purposes.
      </p>
      <p>The information we collect includes:</p>
      <p>
        Log and Usage Data. Log and usage data is service-related, diagnostic,
        usage and performance information our servers automatically collect when
        you access or use our Website and which we record in log files.
        Depending on how you interact with us, this log data may include your IP
        address, device information, browser type and settings and information
        about your activity in the Website (such as the date/time stamps
        associated with your usage, pages and files viewed, searches and other
        actions you take such as which features you use), device event
        information (such as system activity, error reports (sometimes called
        'crash dumps') and hardware settings). Location Data. We collect
        location data such as information about your device's location, which
        can be either precise or imprecise. How much information we collect
        depends on the type and settings of the device you use to access the
        Website. For example, we may use GPS and other technologies to collect
        geolocation data that tells us your current location (based on your IP
        address). You can opt out of allowing us to collect this information
        either by refusing access to the information or by disabling your
        Location setting on your device. Note however, if you choose to opt out,
        you may not be able to use certain aspects of the Services.
      </p>

      <h3>HOW DO WE USE YOUR INFORMATION?</h3>
      <p>
        In Short: We process your information for purposes based on legitimate
        business interests, the fulfillment of our contract with you, compliance
        with our legal obligations, and/or your consent.
      </p>
      <p>
        We use personal information collected via our Website for a variety of
        business purposes described below. We process your personal information
        for these purposes in reliance on our legitimate business interests, in
        order to enter into or perform a contract with you, with your consent,
        and/or for compliance with our legal obligations. We indicate the
        specific processing grounds we rely on next to each purpose listed
        below.
      </p>
      <p>We use the information we collect or receive:</p>
      <p>
        To facilitate account creation and logon process. If you choose to link
        your account with us to a third-party account (such as your Google or
        Facebook account), we use the information you allowed us to collect from
        those third parties to facilitate account creation and logon process for
        the performance of the contract. To post testimonials. We post
        testimonials on our Website that may contain personal information. Prior
        to posting a testimonial, we will obtain your consent to use your name
        and the content of the testimonial. If you wish to update, or delete
        your testimonial, please contact us at support@alphacapitalgroup.uk and
        be sure to include your name, testimonial location, and contact
        information. Request feedback. We may use your information to request
        feedback and to contact you about your use of our Website. To enable
        user-to-user communications. We may use your information in order to
        enable user-to- user communications with each user's consent.
        <br />
        To manage user accounts. We may use your information for the purposes of
        managing our account and keeping it in working order. To send
        administrative information to you. We may use your personal information
        to send you product, service and new feature information and/or
        information about changes to our terms, conditions, and policies.
        <br />
        To protect our Services. We may use your information as part of our
        efforts to keep our Website safe and secure (for example, for fraud
        monitoring and prevention).
        <br />
        To enforce our terms, conditions and policies for business purposes, to
        comply with legal and regulatory requirements or in connection with our
        contract.
        <br />
        To respond to legal requests and prevent harm. If we receive a subpoena
        or other legal request, we may need to inspect the data we hold to
        determine how to respond.
        <br />
        Fulfill and manage your orders. We may use your information to fulfill
        and manage your orders, payments, returns, and exchanges made through
        the Website.
        <br />
        Administer prize draws and competitions. We may use your information to
        administer prize draws and competitions when you elect to participate in
        our competitions.
        <br />
        To deliver and facilitate delivery of services to the user. We may use
        your information to provide you with the requested service.
        <br />
        To respond to user inquiries/offer support to users. We may use your
        information to respond to your inquiries and solve any potential issues
        you might have with the use of our Services.
        <br />
        To send you marketing and promotional communications. We and/or our
        third-party marketing partners may use the personal information you send
        to us for our marketing purposes, if this is in accordance with your
        marketing preferences. For example, when expressing an interest in
        obtaining information about us or our Website, subscribing to marketing
        or otherwise contacting us, we will collect personal information from
        you. You can opt-out of our marketing emails at any time (see the "WHAT
        ARE YOUR PRIVACY RIGHTS?" below).
        <br />
        Deliver targeted advertising to you. We may use your information to
        develop and display personalized content and advertising (and work with
        third parties who do so) tailored to your interests and/or location and
        to measure its effectiveness.
        <br />
        For other business purposes. We may use your information for other
        business purposes, such as data analysis, identifying usage trends,
        determining the effectiveness of our promotional campaigns and to
        evaluate and improve our Website, products, marketing and your
        experience. We may use and store this information in aggregated and
        anonymized form so that it is not associated with individual end users
        and does not include personal information.
      </p>

      <h3>WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>
      <p>
        In Short: We only share information with your consent, to comply with
        laws, to provide you with services, to protect your rights, or to
        fulfill business obligations.
      </p>
      <p>
        We may process or share your data that we hold based on the following
        legal basis:
      </p>
      <p>
        Consent: We may process your data if you have given us specific consent
        to use your personal information for a specific purpose.
        <br />
        Legitimate Interests: We may process your data when it is reasonably
        necessary to achieve our legitimate business interests.
        <br />
        Performance of a Contract: Where we have entered into a contract with
        you, we may process your personal information to fulfill the terms of
        our contract.
        <br />
        Legal Obligations: We may disclose your information where we are legally
        required to do so in order to comply with applicable law, governmental
        requests, a judicial proceeding, court order, or legal process, such as
        in response to a court order or a subpoena (including in response to
        public authorities to meet national security or law enforcement
        requirements).
        <br />
        Vital Interests: We may disclose your information where we believe it is
        necessary to investigate, prevent, or take action regarding potential
        violations of our policies, suspected fraud, situations involving
        potential threats to the safety of any person and illegal activities, or
        as evidence in litigation in which we are involved. More specifically,
        we may need to process your data or share your personal information in
        the following situations:
      </p>
      <p>
        Business Transfers. We may share or transfer your information in
        connection with, or during negotiations of, any merger, sale of company
        assets, financing, or acquisition of all or a portion of our business to
        another company.
        <br />
        Vendors, Consultants and Other Third-Party Service Providers. We may
        share your data with third-party vendors, service providers, contractors
        or agents who perform services for us or on our behalf and require
        access to such information to do that work. Examples include: payment
        processing, data analysis, email delivery, hosting services, customer
        service and marketing efforts. We may allow selected third parties to
        use tracking technology on the Website, which will enable them to
        collect data on our behalf about how you interact with our Website over
        time. This information may be used to, among other things, analyze and
        track data, determine the popularity of certain content, pages or
        features, and better understand online activity. Unless described in
        this notice, we do not share, sell, rent or trade any of your
        information with third parties for their promotional purposes. We have
        contracts in place with our data processors, which are designed to help
        safeguard your personal information. This means that they cannot do
        anything with your personal information unless we have instructed them
        to do it. They will also not share your personal information with any
        organization apart from us. They also commit to protect the data they
        hold on our behalf and to retain it for the period we instruct.
        <br />
        Affiliates. We may share your information with our affiliates, in which
        case we will require those affiliates to honor this privacy notice.
        Affiliates include our parent company and any subsidiaries, joint
        venture partners or other companies that we control or that are under
        common control with us.
        <br />
        Business Partners. We may share your information with our business
        partners to offer you certain products, services or promotions.
      </p>

      <h3>WHO WILL YOUR INFORMATION BE SHARED WITH?</h3>
      <p>
        In Short: We only share information with the following categories of
        third parties.
      </p>
      <p>
        We only share and disclose your information with the following
        categories of third parties. If we have processed your data based on
        your consent and you wish to revoke your consent, please contact us
        using the contact details provided in the section below titled "HOW CAN
        YOU CONTACT US ABOUT THIS NOTICE?".
      </p>
      <p>
        Payment Processors
        <br />
        Ad Networks
        <br />
        Data Analytics Services
        <br />
        Finance & Accounting Tools
        <br />
        Order Fulfillment Service Provider
        <br />
        User Account Registration & Authentication Services
      </p>

      <h3>HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
      <p>
        In Short: We keep your information for as long as necessary to fulfill
        the purposes outlined in this privacy notice unless otherwise required
        by law.
      </p>
      <p>
        We will only keep your personal information for as long as it is
        necessary for the purposes set out in this privacy notice, unless a
        longer retention period is required or permitted by law (such as tax,
        accounting or other legal requirements). No purpose in this notice will
        require us keeping your personal information for longer than six (6)
        months past the termination of the user's account.
      </p>
      <p>
        When we have no ongoing legitimate business need to process your
        personal information, we will either delete or anonymize such
        information, or, if this is not possible (for example, because your
        personal information has been stored in backup archives), then we will
        securely store your personal information and isolate it from any further
        processing until deletion is possible.
      </p>

      <h3>HOW DO WE KEEP YOUR INFORMATION SAFE?</h3>
      <p>
        In Short: We aim to protect your personal information through a system
        of organizational and technical security measures.
      </p>
      <p>
        We have implemented appropriate technical and organizational security
        measures designed to protect the security of any personal information we
        process. However, despite our safeguards and efforts to secure your
        information, no electronic transmission over the Internet or information
        storage technology can be guaranteed to be 100% secure, so we cannot
        promise or guarantee that hackers, cybercriminals, or other unauthorized
        third parties will not be able to defeat our security, and improperly
        collect, access, steal, or modify your information. Although we will do
        our best to protect your personal information, transmission of personal
        information to and from our Website is at your own risk. You should only
        access the Website within a secure environment.
      </p>

      <h3>DO WE COLLECT INFORMATION FROM MINORS?</h3>
      <p>
        In Short: We do not knowingly collect data from or market to children
        under 18 years of age.
      </p>
      <p>
        We do not knowingly solicit data from or market to children under 18
        years of age. By using the Website, you represent that you are at least
        18 or that you are the parent or guardian of such a minor and consent to
        such minor dependent's use of the Website. If we learn that personal
        information from users less than 18 years of age has been collected, we
        will deactivate the account and take reasonable measures to promptly
        delete such data from our records. If you become aware of any data we
        may have collected from children under age 18, please contact us at
        support@alphacapitalgroup.uk.
      </p>

      <h3>WHAT ARE YOUR PRIVACY RIGHTS?</h3>
      <p>
        In Short: In some regions, such as the European Economic Area (EEA) and
        United Kingdom (UK), you have rights that allow you greater access to
        and control over your personal information. You may review, change, or
        terminate your account at any time.
      </p>
      <p>
        In some regions (like the EEA and UK), you have certain rights under
        applicable data protection laws. These may include the right (i) to
        request access and obtain a copy of your personal information, (ii) to
        request rectification or erasure; (iii) to restrict the processing of
        your personal information; and (iv) if applicable, to data portability.
        In certain circumstances, you may also have the right to object to the
        processing of your personal information. To make such a request, please
        use the contact details provided below. We will consider and act upon
        any request in accordance with applicable data protection laws.
      </p>
      <p>
        If we are relying on your consent to process your personal information,
        you have the right to withdraw your consent at any time. Please note
        however that this will not affect the lawfulness of the processing
        before its withdrawal, nor will it affect the processing of your
        personal information conducted in reliance on lawful processing grounds
        other than consent.
      </p>
      <p>
        If you are a resident in the EEA or UK and you believe we are unlawfully
        processing your personal information, you also have the right to
        complain to your local data protection supervisory authority. You can
        find their contact details here:
        <br />
        https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.
      </p>
      <p>
        If you are a resident in Switzerland, the contact details for the data
        protection authorities are available here:
        <br />
        https://www.edoeb.admin.ch/edoeb/en/home.html.
      </p>
      <p>
        If you have questions or comments about your privacy rights, you may
        email us at support@alphacapitalgroup.uk.
      </p>
      <p>Account Information</p>
      <p>
        If you would at any time like to review or change the information in
        your account or terminate your account, you can:
      </p>
      <p>
        Contact us using the contact information provided.
        <br /> Upon your request to terminate your account, we will deactivate
        or delete your account and information from our active databases.
        However, we may retain some information in our files to prevent fraud,
        troubleshoot problems, assist with any investigations, enforce our Terms
        of Use and/or comply with applicable legal requirements.
      </p>
      <p>
        Opting out of email marketing: You can unsubscribe from our marketing
        email list at any time by clicking on the unsubscribe link in the emails
        that we send or by contacting us using the details provided below. You
        will then be removed from the marketing email list — however, we may
        still communicate with you, for example to send you service-related
        emails that are necessary for the administration and use of your
        account, to respond to service requests, or for other non-marketing
        purposes. To otherwise opt-out, you may:
      </p>
      <p>Contact us using the contact information provided.</p>

      <h3>CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
      <p>
        Most web browsers and some mobile operating systems and mobile
        applications include a Do-Not-Track ("DNT") feature or setting you can
        activate to signal your privacy preference not to have data about your
        online browsing activities monitored and collected. At this stage no
        uniform technology standard for recognizing and implementing DNT signals
        has been finalized. As such, we do not currently respond to DNT browser
        signals or any other mechanism that automatically communicates your
        choice not to be tracked online. If a standard for online tracking is
        adopted that we must follow in the future, we will inform you about that
        practice in a revised version of this privacy notice.
      </p>

      <h3>DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>
      <p>
        In Short: Yes, if you are a resident of California, you are granted
        specific rights regarding access to your personal information.
      </p>
      <p>
        California Civil Code Section 1798.83, also known as the "Shine The
        Light" law, permits our users who are California residents to request
        and obtain from us, once a year and free of charge, information about
        categories of personal information (if any) we disclosed to third
        parties for direct marketing purposes and the names and addresses of all
        third parties with which we shared personal information in the
        immediately preceding calendar year. If you are a California resident
        and would like to make such a request, please submit your request in
        writing to us using the contact information provided below.
      </p>
      <p>
        If you are under 18 years of age, reside in California, and have a
        registered account with the Website, you have the right to request
        removal of unwanted data that you publicly post on the Website. To
        request removal of such data, please contact us using the contact
        information provided below, and include the email address associated
        with your account and a statement that you reside in California. We will
        make sure the data is not publicly displayed on the Website, but please
        be aware that the data may not be completely or comprehensively removed
        from all our systems (e.g. backups, etc.).
      </p>

      <h3>DO WE MAKE UPDATES TO THIS NOTICE?</h3>
      <p>
        In Short: Yes, we will update this notice as necessary to stay compliant
        with relevant laws.
      </p>
      <p>
        We may update this privacy notice from time to time. The updated version
        will be indicated by an updated "Revised" date and the updated version
        will be effective as soon as it is accessible. If we make material
        changes to this privacy notice, we may notify you either by prominently
        posting a notice of such changes or by directly sending you a
        notification. We encourage you to review this privacy notice frequently
        to be informed of how we are protecting your information.
      </p>

      <h3>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
      <p>
        If you have questions or comments about this notice, you may email us at
        support@alphacapitalgroup.uk or by post to:
      </p>
      <p>Alpha Capital Group Limited</p>
      <p>
        10 Lower Thames Street Billingsgate
        <br />
        London EC3R 6AF
      </p>
      <p>United Kingdom</p>

      <h3>
        HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
      </h3>
      <p>
        Based on the applicable laws of your country, you may have the right to
        request access to the personal information we collect from you, change
        that information, or delete it in some circumstances. To request to
        review, update, or delete your personal information, please submit a
        request form by clicking here.
      </p>
    </div>
  );
};
export const TermsAndConditions = ({
  isChecked,
  setIsChecked,
  setShowTNC,
  handleNavigationLinks,
  countryCheck,
  platformVal,
  isCheckedError,
  setIsCheckedError,
}) => {
  // Array of checkbox configurations
  const checkboxItems = [
    {
      key: "tnc",
      label: (
        <p>
          I declare that I have read and agree with &nbsp;
          <span
            style={{ color: "#1f69ff", cursor: "pointer" }}
            role="button"
            tabIndex={0}
            onClick={(e) => setShowTNC(true)}
          >
            <span
              style={{ color: "#1f69ff", cursor: "pointer" }}
              role="button"
              tabIndex={0}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   handleNavigationLinks(
              //     "https://alphacapitalgroup.uk/terms-and-conditions/"
              //   );
              // }}
            >
              Terms & Conditions, &nbsp;
            </span>
            <span
              style={{ color: "#1f69ff", cursor: "pointer" }}
              role="button"
              tabIndex={0}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   handleNavigationLinks(
              //     "https://alphacapitalgroup.uk/privacy-policy-2/"
              //   );
              // }}
            >
              Privacy Policy, &nbsp;
            </span>
            <span
              style={{ color: "#1f69ff", cursor: "pointer" }}
              role="button"
              tabIndex={0}
            >
              General Service Agreement, Trading terms and conditions.
            </span>
          </span>
          *
        </p>
      ),
      required: true,
    },
    {
      key: "not_us_resident",
      label: <p>I'm not a US resident or citizen.*</p>,
      condition:
        countryCheck !== "US" &&
        platformVal !== "DX Trade" &&
        platformVal !== "Alpha Trader" &&
        platformVal !== "Trade Locker",
      required:
        (countryCheck !== "US" &&
          platformVal !== "DX Trade" &&
          platformVal !== "Alpha Trader" &&
          platformVal !== "Trade Locker") === false
          ? false
          : true,
    },
    {
      key: "acknowledge_personal_data",
      label: (
        <p>
          I acknowledge that signing up with personal details that do not match
          my ID/Personal information will lead to suspension of my payout(s) and
          closure of my account(s).*
        </p>
      ),
      required: true,
    },
    // {
    //   key: "agree_to_news_letters",
    //   label: <p>I agree to receive newsletters, news, and product updates.</p>,
    //   required: false,
    // },
    // {
    //   key: "marketing_opt_in",
    //   label: (
    //     <p>
    //       Send me an exclusive welcome offer, trader insights, product updates
    //       and discounts from Alpha Capital Group by email. You can unsubscribe
    //       at any time.{" "}
    //     </p>
    //   ),
    //   required: false,
    // },
  ];

  const checkValidation = () => {
    const requiredItems = checkboxItems.filter((item) => item.required);
    const allRequiredChecked = requiredItems.every(
      (item) => isChecked[item.key] === true,
    );
    return allRequiredChecked;
  };

  const handleCheckboxChange = (key) => (e) => {
    const newCheckedState = {
      ...isChecked,
      [key]: e.target.checked,
    };
    setIsChecked(newCheckedState);

    // Validate immediately after state update
    const allRequiredChecked = checkboxItems
      .filter((item) => item.required)
      .every((item) => newCheckedState[item.key] === true);
    setIsCheckedError(
      allRequiredChecked ? "" : "Please accept the terms and conditions",
    );
  };

  // Optional: Sync error state on mount or prop changes
  useEffect(() => {
    const allRequiredChecked = checkValidation();
    setIsCheckedError(
      allRequiredChecked ? "" : "Please accept the terms and conditions",
    );
  }, [isChecked, countryCheck, platformVal]);

  return (
    <div className="term_and_conditions">
      {checkboxItems.map((item) =>
        item.condition === false ? null : (
          <FormControlLabel
            key={item.key}
            control={
              <Checkbox
                checked={isChecked[item.key]}
                onChange={handleCheckboxChange(item.key)}
                sx={{ marginTop: "0px", borderRadius: "4px" }}
              />
            }
            label={item.label}
            componentsProps={{
              typography: {
                onClick: (e) => {
                  e.preventDefault();
                  // handleCheckboxChange(item.key)({ target: { checked: !isChecked[item.key] } });
                },
                style: { cursor: "pointer" },
              },
            }}
          />
        ),
      )}
      {/* <PrivacyPolicy /> */}
      {isCheckedError && (
        <p className="error-msg" style={{ color: "red" }}>
          {isCheckedError}
        </p>
      )}
    </div>
  );
};

export const CustomerInformation = ({
  selectedStep,
  selectedPlan,
  selectedChallenge,
  selectedPlatform,
  selectedPayoutType,
  coupon,
  setCoupon,
  finalPrice,
  setFinalPrice,
  validateCouponCode,
  removeCoupon,
  isChecked,
  setIsChecked,
  setShowTNC,
  handleNavigationLinks,
  countryCheck,
  confirmPaymentClick,
  handleFinalPayment,
  dollarUS, // Currency formatting function
  isCheckedError,
  setIsCheckedError,
  isCouponLoading,
  selectedProfitSplit,
  showProfitSplit,
}) => {
  console.log("selectedPlan", selectedPlan);

  const hideProfitTarget2 =
    selectedPlan?.plan_type?.toLowerCase()?.includes("alpha one") ||
    (selectedStep?.step &&
      String(selectedStep.step).toLowerCase().includes("alpha one"));

  const dropdownItems = [
    { label: "Leverage", value: `1:${selectedChallenge?.Leverage}` },
    {
      label: "Profit Target 1",
      value: dollarUS(selectedChallenge?.Evaluation_Phase_1),
    },
    ...(selectedPlan?.plan_type &&
    selectedPlan?.plan_type !== "Free Trial" &&
    selectedChallenge?.Evaluation_Phase_2 > 0 &&
    !hideProfitTarget2
      ? [
          {
            label: "Profit Target 2",
            value: dollarUS(selectedChallenge?.Evaluation_Phase_2),
          },
        ]
      : []),

    ...(selectedChallenge?.Evaluation_Phase_3 > 0
      ? [
          {
            label: "Profit Target 3",
            value: dollarUS(selectedChallenge?.Evaluation_Phase_3),
          },
        ]
      : []),
    {
      label:
        selectedPlan?.plan_type?.toLowerCase()?.includes("alpha one") &&
        selectedChallenge?.trailing_mll !== 0
          ? "Trailing Max Loss"
          : "Max Loss",
      value:
        selectedPlan?.plan_type?.toLowerCase()?.includes("alpha one") &&
        selectedChallenge?.trailing_mll !== 0
          ? selectedChallenge?.trailing_mll <= 100
            ? `${selectedChallenge?.trailing_mll}%`
            : `${((selectedChallenge?.trailing_mll / selectedChallenge?.account_balance) * 100).toFixed(2)}%`
          : dollarUS(selectedChallenge?.Max_Loss),
    },
    {
      label: "Max Daily Loss",
      value: dollarUS(selectedChallenge?.Max_Daily_Loss),
    },
    ...(selectedPlan?.plan_type !== "Free Trial"
      ? [
          {
            label: "Profit Split",
            value:
              selectedChallenge?.Profit_Split === "N/A"
                ? "-"
                : `${
                    showProfitSplit && selectedProfitSplit
                      ? selectedProfitSplit
                      : selectedChallenge?.Profit_Split || 80
                  }%`,
          },
        ]
      : []),
    ...(selectedChallenge?.plan_type?.toLowerCase()?.includes("free trial")
      ? []
      : selectedChallenge?.plan_type?.toLowerCase().includes("swing") ||
          selectedChallenge?.plan_type?.toLowerCase().includes("alpha one")
        ? [
            {
              label: "On Demand Payout",
              value: "Yes",
            },
          ]
        : [
            {
              label:
                selectedPayoutType === 1
                  ? "Bi Weekly Profit Split"
                  : "On Demand Payout",
              value: selectedChallenge?.Bi_Weekly_Profit_Split ? "Yes" : "No",
            },
          ]),
    // {
    //   label: "Max Capital Growth",
    //   value: dollarUS(selectedChallenge?.Max_Capital_Growth) || "-",
    // },
  ];

  return (
    <div className="customer_inforamtion">
      <div className="order_summary_header_sec">
        <h2 className="order_summary_title">Order Summary</h2>
      </div>
      <div className="Summary-section">
        {selectedPlan?.plan_type !== "Free Trial" && (
          <div className="discount_container">
            <h2 className="discount_title">Discount Code</h2>
            {!removeCoupon && (
              <div className="couponLine">
                <div className="coupon_container">
                  <input
                    className="coupon_input_field"
                    placeholder="Enter code"
                    type="text"
                    value={coupon?.value ? coupon?.value : ""}
                    onBlur={validateCouponCode}
                    onChange={(e) =>
                      setCoupon((prev) => ({
                        ...prev,
                        value: e.target.value.replace(/\s/g, ""),
                      }))
                    }
                    style={coupon?.error ? { border: "2px solid #fd2d2d" } : {}}
                    disabled={
                      coupon?.error
                        ? false
                        : (finalPrice?.discount && coupon?.value) ||
                          isCouponLoading
                    }
                  />
                  <button
                    onClick={validateCouponCode}
                    className={`coupon_apply_btn ${
                      coupon?.error
                        ? "error"
                        : finalPrice?.discount && coupon?.value
                          ? "applied"
                          : ""
                    }`}
                    disabled={
                      coupon?.error ||
                      (finalPrice?.discount && coupon?.value) ||
                      isCouponLoading
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {isCouponLoading ? (
                      <CircularProgress
                        size={20}
                        style={{ color: "#ffffff" }}
                      />
                    ) : finalPrice?.discount &&
                      coupon?.value &&
                      !coupon?.error ? (
                      "Applied"
                    ) : (
                      "Apply"
                    )}
                  </button>
                </div>
                {coupon?.error && (
                  <small
                    style={{
                      color: "#fd2d2d",
                      textAlign: "left",
                      float: "left",
                      width: "100%",
                      marginTop: "5px",
                    }}
                  >
                    Invalid coupon
                  </small>
                )}
                {finalPrice?.discount && coupon?.value && !coupon?.error ? (
                  <div className="couponValue" style={{ marginTop: "10px" }}>
                    <p>{coupon.value}</p>
                    <img
                      src={clearicon}
                      alt="Remove applied coupon"
                      onClick={() => {
                        setCoupon({ value: "", error: false });
                        setFinalPrice((prev) => ({}));
                      }}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )}
        <div className="checkout-info-container">
          {selectedStep && (
            <div className="checkout_info_inner">
              <h2>Step</h2>
              <h3>{selectedStep?.step || "N/A"}</h3>
            </div>
          )}
          <div className="checkout_info_inner">
            <h2>Account</h2>
            <h3>{selectedPlan?.plan_type || "N/A"}</h3>
          </div>
          <div className="checkout_info_inner">
            <h2>Account Size</h2>
            <h3>{dollarUS(selectedChallenge?.account_balance || 0)}</h3>
          </div>
          <div className="checkout_info_inner">
            <h2>Platform</h2>
            <h3>{selectedPlatform?.name || "N/A"}</h3>
          </div>
        </div>

        {/* <div className="dropdown-container dropdownOpen">
        <button className="see_more">
          <h2>{selectedPlan?.plan_type || "Details"}</h2>
        </button>
        <div
          className="dropdown-content open"
          onClick={(e) => e.stopPropagation()}
        >
          {dropdownItems.map((item, index) => (
            <div key={index} className="dropdown-content_inner">
              <div>
                <img src={greenDot} alt="greenDot" />
                <p>{item.label}</p>
              </div>
              <h4>{item.value}</h4>
            </div>
          ))}
        </div>
      </div> */}

        <div className="discount">
          <div className="calculate_price_with_discount">
            <div>
              <div className="amount-left">
                <p className="dueClass">Total due</p>
                <p className="paymentClass">One-time payment</p>
              </div>
              {/* <h2>{selectedPlan?.plan_type || "N/A"}</h2> */}
              <p>
                {isCouponLoading ? (
                  <span className="loading-dots">
                    Loading<span className="dot">.</span>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                  </span>
                ) : (
                  dollarUS(finalPrice?.discounted_price ?? finalPrice?.actual_price ?? selectedChallenge?.Price)
                )}
              </p>
            </div>
            {finalPrice?.discounts?.length > 0 && (
              <>
                <h2 style={{ textAlign: "start" }}>Discount</h2>
                {finalPrice.discounts.map((discountItem, index) => (
                  <div key={index}>
                    <p>
                      {discountItem.coupon || discountItem?.name} -
                      {discountItem.discount_percent}% off
                    </p>
                    <p>- {dollarUS(discountItem.discount)}</p>
                  </div>
                ))}
              </>
            )}
            {/* <div className="final_price">
            <p>Total</p>
            <p>
              {isCouponLoading ? (
                <span className="loading-dots">
                  Loading<span className="dot">.</span>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                </span>
              ) : (
                dollarUS(
                  finalPrice?.discounted_price || selectedChallenge?.Price,
                )
              )}
            </p>
          </div> */}
          </div>

          <span>By confirming the order:</span>
          <TermsAndConditions
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            setShowTNC={setShowTNC}
            handleNavigationLinks={handleNavigationLinks}
            countryCheck={countryCheck}
            platformVal={selectedPlatform?.name}
            isCheckedError={isCheckedError}
            setIsCheckedError={setIsCheckedError}
          />
        </div>

        <CustomLoadingButton
          disabled={confirmPaymentClick}
          onClick={handleFinalPayment}
          loading={confirmPaymentClick}
          className="proceed_btn"
          text="Continue to Payment"
          sx={{ color: "white" }}
          endIcon={false}
        />
      </div>
    </div>
  );
};

export const handleApplyCoupon = async (
  coupon, // { value: 'SOMECOUPON' }
  selectedPayoutType,
  selectedChallenge_id,
  idToken,
  setCheckout, // updates final price
  setCouponError, // function: (boolean) => void
  publicCheckout,
  tradingPlatform,
  profitSplit,
  swapFree,
) => {
  const params = {
    ...(coupon?.value && { coupon: coupon?.value }),
    ...(selectedPayoutType === 2 && { ondemand: selectedPayoutType === 2 }),
    platform: tradingPlatform,
    ...(profitSplit && { profit_split: profitSplit }),
    ...(swapFree !== undefined && { swap_free: swapFree }),
  };

  const config = {
    headers: {
      ...(!publicCheckout ? { Authorization: `Bearer ${idToken}` } : {}),
      "Content-Type": "application/json",
    },
    params,
  };

  try {
    const response = await axios.get(
      `v2/get/final-price/${selectedChallenge_id}/`,
      config,
    );
    const { data, status } = response;
    if (status === 200) {
      setCouponError(false); // valid coupon, no error
      setCheckout(data);
    }
    return data;
  } catch (error) {
    if (error.response?.data?.detail === "invalid-auth-token") {
      window.location.replace("/");
      console.error("Error applying coupon:", error);
    }
    setCouponError(true); // invalid coupon, set error
    if (error.response) {
      console.error("Server responded with:", error.response.data);
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error setting up request:", error.message);
    }
    throw error;
  }
};

export const freeTrialPaymentInitV4 = async (
  dispatch,
  payload,
  idToken,
  publicCheckout,
) => {
  try {
    const response = await axiosInstance.post(
      "v2/create/free-trial/",
      payload,
      {
        headers: {
          ...(!publicCheckout ? { Authorization: `Bearer ${idToken}` } : []),
          "x-api-key":
            "ONRzS8gkWBRkr76XYyI6z1e6p6NX72x83KABC4dpx90sSxgzF9n3QqlQoBHGvGZKgu3a2hVPVtMeUYxlyILZMK5cZo2VspEKWORYvdN4fk1WVmtALKKlfwAFFXRpBFyIGQOcNHRtn0dsr6YJhhdNXrDh4Fk5dlt4Cns2CPl5e7QgByxNaSpfJE6vewJVsgmp6KMMWnnOqyMmBWw33NQyTbdP0gCwaLHPlspCEWJDokCUFSVf0IwG8hWJkulr5Al",
        },
      },
    );

    if (response.data.success) {
      return response;
    } else {
      throw new Error(
        response.data.message || "Failed to create free trial account",
      );
    }
  } catch (error) {
    console.error("Free trial creation error:", error);
    throw error.response?.data || error;
  }
};

export const stripePaymentInitV4 = async (
  dispatch,
  payload,
  idToken,
  publicCheckout,
) => {
  try {
    const requestBody = {};

    for (const key in payload) {
      if (
        Object.hasOwn(payload, key) &&
        payload[key] !== undefined &&
        payload[key] !== null &&
        payload[key] !== ""
      ) {
        requestBody[key] = payload[key];
      }
    }

    // Special case for nacepayment: override cryptocurrency
    if (payload?.payment_method === "nacepayment") {
      requestBody.cryptocurrency = "erc20/usdt";
    }
    const objectToFormData = (payload) => {
      const formData = new FormData();

      for (const key in payload) {
        if (
          Object.hasOwn(payload, key) &&
          payload[key] !== undefined &&
          payload[key] !== null &&
          payload[key] !== ""
        ) {
          formData.append(key, payload[key]);
        }
      }

      return formData;
    };
    const formData = objectToFormData(payload);
    // Make the API request with JSON body
    const { data } = await axiosInstance.post(
      "v2/get/checkout/payment-url/",
      formData,
      {
        headers: {
          // "Content-Type": "application/json",
          ...(!publicCheckout ? { Authorization: `Bearer ${idToken}` } : []),
        },
      },
    );

    // Handle invalid token response
    if (data === "Please verify the Access Token!") {
      dispatch(logoutReducer());
      return;
    }

    // Dispatch actions with response data
    dispatch(savePaymentIntent(data.data.payment_id));
    dispatch(addChallenge(payload));

    return data;
  } catch (error) {
    // Handle token verification error
    if (error === "Please verify the Access Token!") {
      dispatch(logoutReducer());
      return;
    }
    // Throw the error response data for upstream handling
    throw error.response?.data || error;
  }
};

export const CustomerInfoForm = ({
  publicCheckout,
  basicDetails,
  setBasicDetails,
  checkValidate,
  setShowTnc,
  allErrors,
  basicDetailsDisabled,
}) => {
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    let error = "";

    // Common fields validation (always present)
    switch (name) {
      case "first_name":
        if (!value.trim()) {
          error = "First Name is required";
        } else if (value.length < 1) {
          error = "Must be at least 1 characters";
        } else if (value.length > 40) {
          error = "Must be at most 40 characters";
        } else if (/[0-9]/.test(value)) {
          error = "Numbers are not allowed";
        }
        break;

      case "last_name":
        if (!value.trim()) {
          error = "Last Name is required";
        } else if (value.length < 1) {
          error = "Must be at least 1 characters";
        } else if (value.length > 40) {
          error = "Must be at most 40 characters";
        } else if (/[0-9]/.test(value)) {
          error = "Numbers are not allowed";
        }
        break;
      case "email":
        if (!value) {
          error = "Email is required";
        } else if (value.length > 50) {
          error = "Email must be at most 50 characters";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          error = "Invalid email format";
        }
        break;

      case "contact":
        if (!value) {
          error = "Phone number is required";
        } else if (!/^\d+$/.test(value)) {
          error = "Phone number must contain only digits";
        } else if (value.length > 15) {
          error = "Phone number must not exceed 15 digits";
        }
        break;

      case "country_code":
        if (!value) {
          error = "Country code is required";
        } else if (!/^\+?\d{1,3}-?\d{0,3}$/.test(value)) {
          error = "Invalid country code format";
        }
        break;
    }

    // Conditional fields based on publicCheckout
    if (publicCheckout) {
      switch (name) {
        case "confirmEmail":
          if (!value) {
            error = "Confirm Email is required";
          } else if (value !== basicDetails.email) {
            error = "Emails must match";
          }
          break;
      }
    } else {
      switch (name) {
        case "City":
          if (!value.trim()) {
            error = "City is required";
          } else if (value !== value.trim()) {
            error = "City cannot start or end with spaces";
          } else if (!/[\p{L}]/u.test(value)) {
            error = "City must contain at least one letter";
          } else if (!/^[\p{L}\p{M}\d\s',.\-]+$/u.test(value)) {
            error =
              "Only letters, numbers, spaces, hyphens, apostrophes, commas, and periods are allowed";
          } else if (/^\s|\s$/.test(value)) {
            error = "City cannot start or end with spaces";
          } else if (/\s{2,}/.test(value)) {
            error = "City cannot contain consecutive spaces";
          } else if (/,{2,}/.test(value)) {
            error = "City cannot contain consecutive commas";
          } else if (/'{2,}/.test(value)) {
            error = "City cannot contain consecutive apostrophes";
          } else if (value.length < 1) {
            error = "Must be at least 1 character";
          } else if (value.length > 100) {
            error = "Must be at most 100 characters";
          }
          break;

        case "Country":
          if (!value) {
            error = "Country is required";
          } else if (
            !countryOptions?.find((option) => option.value === value)
          ) {
            error = "Invalid country selection";
          }
          break;
      }
    }

    return error;
  };

  const countryOptions = countries.map((country) => ({
    value: country.label,
    label: country.label,
    code: country.phone,
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBasicDetails((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  useEffect(() => {
    if (allErrors) {
      setErrors(allErrors);
    }
  }, [allErrors]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "51px",
      background: "#121212",
      border: errors.Country
        ? "0.711px solid #ff0000"
        : "0.711px solid #141414",
      borderRadius: "5px",
      boxShadow: "none",
      textAlign: "left",
      padding: 0,
      paddingLeft: "12px",
      width: "100%",
      "&:hover": {
        borderColor: errors.Country ? "#ff0000" : "#b8e6ff12",
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: "rgba(255, 255, 255, 0.50)",
    }),
    singleValue: (base) => ({
      ...base,
      color: "rgba(255, 255, 255, 0.50)",
    }),
    input: (base) => ({
      ...base,
      color: "rgba(255, 255, 255, 0.50)",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#191e20",
      background: "#191e20",
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      maxHeight: "120px",
      overflowY: "auto",
      backgroundColor: "#191e20",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#0d56eb"
        : state.isFocused
          ? "#ffffff1a"
          : "#9f9f9f0d",
      color: "rgba(255, 255, 255, 0.50)ffffff",
      padding: "10px",
      textAlign: "left",
      cursor: "pointer",
      zIndex: 1111,
      maxHeight: "100px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(255, 255, 255, 0.50)fff",
      textAlign: "left",
      padding: "0px !important",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#ffffff",
      cursor: "pointer",
    }),
    input: (base) => ({
      ...base,
      color: "rgba(255, 255, 255, 0.50)ffffff",
      textAlign: "left",
      paddingLeft: "0",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff80",
      textAlign: "left",
    }),
  };

  return (
    <div className="custom_info">
      <div className="account_balance_header">
        <h2>Customer Information</h2>
        <p>
          Enter your personal details to complete your registration and account
          setup.
        </p>
      </div>
      <div className="custom_info_inner">
        <div className="input-wrapper">
          <label htmlFor="first_name" className="input-label">
            First Name
          </label>
          {/* <img src={ProfileIcon} alt="Profile Icon" /> */}
          <input
            id="first_name"
            name="first_name"
            size="small"
            placeholder="First Name *"
            value={basicDetails.first_name || ""}
            onChange={handleChange}
            aria-label="First Name"
            required
            disabled={!publicCheckout && basicDetailsDisabled.first_name}
          />
          {errors.first_name && (
            <span className="error">{errors.first_name}</span>
          )}
        </div>

        <div className="input-wrapper">
          <label htmlFor="last_name" className="input-label">
            Last Name
          </label>
          {/* <img src={ProfileIcon} alt="Profile Icon" /> */}
          <input
            id="last_name"
            name="last_name"
            size="small"
            placeholder="Last Name *"
            value={basicDetails.last_name || ""}
            onChange={handleChange}
            aria-label="Last Name"
            required
            disabled={!publicCheckout && basicDetailsDisabled.last_name}
          />
          {errors.last_name && (
            <span className="error">{errors.last_name}</span>
          )}
        </div>

        <div className="input-wrapper">
          <label htmlFor="email" className="input-label">
            Email
          </label>
          {/* <img src={EmailIcon} alt="Email Icon" /> */}
          <input
            id="email"
            name="email"
            size="small"
            placeholder="Email *"
            type="email"
            value={basicDetails.email}
            onChange={handleChange}
            aria-label="Email"
            required
            disabled={!publicCheckout && basicDetailsDisabled.email}
          />
          {errors.email && <span className="error">{errors.email}</span>}
        </div>
        <div className="input-wrapper phone-wrapper">
          <label className="input-label">Phone Number</label>
          <div className="" id="contactAndCode">
            {/* <img src={ContactNumber} alt="Contact Number Icon" /> */}
            <div
              className="phone-input-wrapper"
              style={{ display: "flex", alignItems: "center" }}
            >
              <span style={{ paddingRight: "4px" }}>+</span>
              <input
                id="country_code"
                name="country_code"
                type="tel"
                placeholder="Code"
                value={basicDetails.country_code || ""}
                onChange={handleChange}
                aria-label="country code"
                className="country_code"
              />
            </div>
            <input
              id="contact"
              name="contact"
              size="small"
              type="tel"
              placeholder="Contact Number *"
              value={basicDetails.contact || ""}
              onChange={handleChange}
              aria-label="Contact Number"
              // disabled={!publicCheckout && basicDetailsDisabled.contact}
            />
          </div>
          {errors.country_code && (
            <span className="error">{errors.country_code}</span>
          )}
          {errors.contact && <span className="error">{errors.contact}</span>}
        </div>

        {publicCheckout ? (
          <div className="input-wrapper">
            <label htmlFor="confirmEmail" className="input-label">
              Confirm Email
            </label>
            {/* <img src={EmailIcon} alt="Email Icon" /> */}
            <input
              id="confirmEmail"
              name="confirmEmail"
              size="small"
              placeholder="Confirm Email *"
              value={basicDetails.confirmEmail}
              onChange={handleChange}
              onPaste={(e) => e.preventDefault()}
              required
            />
            {errors.confirmEmail ? (
              <span className="error">{errors.confirmEmail}</span>
            ) : (
              basicDetails.confirmEmail === basicDetails.email &&
              basicDetails.confirmEmail !== "" && (
                <img
                  src={CheckSolidGreenIcon}
                  alt="CheckSolidGreenIcon"
                  className="validation-checkmark"
                />
              )
            )}
          </div>
        ) : (
          <>
            <div className="input-wrapper">
              <label htmlFor="City" className="input-label">
                City
              </label>
              {/* <img src={CityIcon} alt="City Icon" /> */}
              <input
                id="City"
                name="City"
                size="small"
                placeholder="City *"
                value={basicDetails.City || ""}
                onChange={handleChange}
                aria-label="City"
                required
                disabled={!publicCheckout && basicDetailsDisabled.City}
              />
              {errors.City && <span className="error">{errors.City}</span>}
            </div>
            <div className="input-wrapper">
              <label htmlFor="Country" className="input-label">
                Country
              </label>
              {/* <img src={CountryIcon} alt="Country Icon" /> */}
              <Select
                className="country-select"
                classNamePrefix="country-select"
                name="Country"
                options={countryOptions}
                value={countryOptions.find(
                  (option) => option.value === basicDetails.Country,
                )}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                isSearchable
                onChange={(selected) => {
                  setBasicDetails((prev) => ({
                    ...prev,
                    Country: selected.value,
                    country_code: selected.code,
                  }));
                  const countryError = validateField("Country", selected.value);
                  const codeError = validateField(
                    "country_code",
                    selected.code,
                  );
                  setErrors((prev) => ({
                    ...prev,
                    Country: countryError,
                    country_code: codeError,
                  }));
                }}
                placeholder="Select Country *"
                inputId="Country"
                styles={customStyles}
                isDisabled={!publicCheckout && basicDetailsDisabled.Country}
              />
              {errors.Country && (
                <span className="error">{errors.Country}</span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export const checkValidate = (details, publicCheckout) => {
  const countryOptions = countries.map((country) => ({
    value: country.label,
    label: country.label,
    code: country.phone,
  }));
  const errors = {};

  // Common fields validation (always present)
  if (!details.first_name?.trim()) errors.first_name = "First Name is required";
  else if (details.first_name.length < 1)
    errors.first_name = "Must be at least 1 characters";
  else if (details.first_name.length > 70)
    errors.first_name = "Must be at most 70 characters";
  else if (/[0-9]/.test(details.first_name))
    errors.first_name = "Only letters, spaces, and hyphens allowed";

  if (!details.last_name?.trim()) errors.last_name = "Last Name is required";
  else if (details.last_name.length < 1)
    errors.last_name = "Must be at least1 characters";
  else if (details.last_name.length > 70)
    errors.last_name = "Must be at most 70 characters";
  else if (/[0-9]/.test(details.last_name))
    errors.last_name = "Only letters, spaces, and hyphens allowed";

  if (!details.email) errors.email = "Email is required";
  else if (details.email.length > 50)
    errors.email = "Email must be at most 50 characters";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(details.email))
    errors.email = "Invalid email format";

  // Validate contact
  if (!details.contact) {
    errors.contact = "Phone number is required";
  } else if (!/^\d+$/.test(details.contact)) {
    errors.contact = "Phone number must contain only digits";
  } else if (details.contact.length < 6) {
    errors.contact = "Phone number must be at least 6 digits";
  } else if (details.contact.length > 15) {
    errors.contact = "Phone number must not exceed 15 digits";
  }

  // Validate country_code
  if (!details.country_code) {
    errors.country_code = "Country code is required";
  } else if (
    !countryOptions?.some(
      (option) => Number(option.code) === Number(details?.country_code),
    )
  ) {
    errors.country_code = "Invalid country code";
  }

  // Conditional validation based on publicCheckout
  if (publicCheckout) {
    if (!details.confirmEmail)
      errors.confirmEmail = "Confirm Email is required";
    else if (details.confirmEmail !== details.email)
      errors.confirmEmail = "Emails must match";
  } else {
    if (!details.City?.trim()) errors.City = "City is required";
    else if (/[0-9]/.test(details.city))
      errors.City = "Only letters, spaces, and hyphens allowed";

    if (!details.Country) errors.Country = "Country is required";
    else if (
      !countryOptions?.find((option) => option.value === details.Country)
    )
      errors.Country = "Invalid country selection";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};

export const TncModal = ({ open, onClose }) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 600) {
        setScale(0.5);
      } else if (screenWidth < 750) {
        setScale(0.8);
      } else {
        setScale(1.2);
      }
    };

    updateScale(); // Set on initial load
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Terms & Conditions"
      width={800}
      bodyStyle={{ padding: 0 }}
      centered
      className="termsConditionModal"
    >
      <PDFPreview
        fileUrl={PDFDoc}
        defaultScale={scale}
        style={{ height: "80vh", width: "100%" }}
      />
    </Modal>
  );
};


export const findChallengeByIdentifier = (challenges, identifier) => {
  if (!Array.isArray(challenges) || !identifier) return null;

  let matchingChallenge = null;
  let matchingPlan = null;
  let matchingStep = null;

  // 1. Try to match by ID first
  const challengeIdNum = Number(identifier);
  if (!isNaN(challengeIdNum)) {
    for (const step of challenges) {
      if (!step?.plans || !Array.isArray(step.plans)) continue;

      for (const plan of step.plans) {
        if (!plan?.challenges || !Array.isArray(plan.challenges)) continue;

        const found = plan.challenges.find(
          (challenge) => Number(challenge?.id) === challengeIdNum,
        );

        if (found) {
          matchingChallenge = found;
          matchingPlan = plan;
          matchingStep = step;
          break;
        }
      }
      if (matchingChallenge) break;
    }
  }

  // 2. If not matched by ID, try matching by name
  if (!matchingChallenge) {
    const normalizedParam = identifier.toLowerCase().replace(/_/g, "-");

    let targetPlanType = "";
    if (normalizedParam.includes("alpha-one")) {
      targetPlanType = "alpha one";
    } else if (normalizedParam.includes("swing")) {
      targetPlanType = "swing";
    } else if (normalizedParam.includes("alpha-pro")) {
      targetPlanType = "alpha pro";
    } else if (normalizedParam.includes("free-trial")) {
      targetPlanType = "free trial";
    } else if (normalizedParam.includes("alpha-three")) {
      targetPlanType = "alpha three";
    }

    const sizeMatch = normalizedParam.match(/(\d+)k/i);
    let targetSize = 0;
    if (sizeMatch) {
      targetSize = parseInt(sizeMatch[1], 10) * 1000;
    }

    const variantMatch = normalizedParam.match(/-(\d+)$/);
    let targetVariant = null;
    if (variantMatch) {
      targetVariant = parseInt(variantMatch[1], 10);
    }

    if (targetPlanType && targetSize > 0) {
      for (const step of challenges) {
        if (!step?.plans || !Array.isArray(step.plans)) continue;

        for (const plan of step.plans) {
          if (!plan?.challenges || !Array.isArray(plan.challenges)) continue;

          if (plan.plan_type.toLowerCase() === targetPlanType) {
            const found = plan.challenges.find((challenge) => {
              const sizeMatches =
                Number(challenge.account_balance) === targetSize;
              if (!sizeMatches) return false;

              if (targetPlanType === "alpha pro" && targetVariant !== null) {
                return challenge.profit_target_in_percent === targetVariant;
              }
              return true;
            });

            if (found) {
              matchingChallenge = found;
              matchingPlan = plan;
              matchingStep = step;
              break;
            }
          }
        }
        if (matchingChallenge) break;
      }
    }
  }

  if (matchingChallenge) {
    return {
      challenge: matchingChallenge,
      plan: matchingPlan,
      step: matchingStep,
    };
  }

  return null;
};
